module.exports = __webpack_public_path__ + "static/featuredLg-ae08939c7fb5cc7b3d1cb0575f3d59bb.svg";